import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { EditBlockBase } from '../../edit-block-base';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateModule } from "@ngx-translate/core";
import { MatError, MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { NgIf } from "@angular/common";

@Component({
  selector: 'session-bloc-edit',
  standalone: true,
  providers: [],
  styleUrls: ['./../component-edit.scss'],
  imports: [
    TranslateModule,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatError,
    NgIf
  ],
  templateUrl: './session-bloc-edit.html'
})
export class SessionBlocEditComponent extends EditBlockBase implements OnInit, AfterViewInit, OnDestroy {

    private subscriptions: Subscription[] = [];
    public repeatMinValue = 1;
    public nbRepeatFormControl: FormControl = new FormControl('1', [
        Validators.required,
        Validators.min(1)
    ]);

    ngOnInit(): void {
        if (this.data.data.nbRepeat) {
            this.nbRepeatFormControl.setValue(this.data.data.nbRepeat);
        }
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(
            this.nbRepeatFormControl.valueChanges.subscribe((value: number) => {
                this.nbRepeatFormControl.markAsTouched();
                if (value < 1) {
                    this.baseComponent.onValuesAreNotGood.emit();
                }else{
                    this.baseComponent.onValuesAreGood.emit();
                }
                this.data.data.nbRepeat = value;
                this.baseComponent.onTimeBasedInfoUpdated.emit();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
